import React from 'react'

import { ArrowWithCircle, GreenTickIcon, RedCrossIcon } from '@application/Interfaces/Icons'
import { ListStyleType, ThemeModeType } from '@src/Application/Types/ComponentTypes'
import { Nullable } from '@src/Application/Types/Opt'

export const getListStyleTypeIcon = (mode: ThemeModeType, listStyleType: Nullable<ListStyleType>): JSX.Element => {
    switch (listStyleType) {
        case 'Red Cross':
            return <RedCrossIcon width={18} height={15} className="icon" />

        case 'Arrow':
            return (
                <ArrowWithCircle
                    fillColorCode={mode === 'Light' ? 'p500' : 'white'}
                    strokeColorCode={mode === 'Light' ? 'white' : 'p500'}
                    width={18}
                    height={15}
                    className="icon"
                />
            )

        default:
            return <GreenTickIcon width={18} height={15} className="icon" />
    }
}
